import React from 'react'
import { ICONS } from '@Const/common'
import './index.scss'

interface RoyaltiesLinkProps {
    pdfString: string
    link: string
    linkText: string
}

const RoyaltiesLink = ({ pdfString, link, linkText }: RoyaltiesLinkProps) => (
    <div className="distribution-notes-link">
        <a href={`https://resources.themlc.com/distribution/${link}-${pdfString}`} target="_blank" rel="noreferrer">
            <img src={ICONS.pdfIcon} alt="pdf" />
            {linkText}
        </a>
    </div>
)

export default RoyaltiesLink
